import React from 'react';
import './styles.less';
import {processTranslation} from '../utils/commonUtil';

// HA Artifactory Imports
import {SVGIcon} from '@homeaway/react-svg';
import {ARROW_LEFT__24} from '@homeaway/svg-defs';

// Third Party Imports
import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import helpIconDefault from '../../images/help-default';
import helpIconHover from '../../images/help-hover';
import emailIconDefault from '../../images/email-default';
import emailIconHover from '../../images/email-hover';

export default class InformationPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    resources() {
        const {
            translations,
            email,
            onEmailIconMouseHovered,
            onEmailIconMouseOut,
            help,
            onHelpIconMouseHovered,
            onHelpIconMouseOut,
            isEmailIconHovered,
            isHelpIconHovered,
            onHelpClick
        } = this.props;

        const helpCenter = translations['ipmob.help_center.link'];

        return (<div className="wrapper">
            <div className="content-col-left text-center email-icon-holder">
                <div>
                    <div id="email-icon" onClick={onHelpClick} onMouseOver={onEmailIconMouseHovered} onMouseOut={onEmailIconMouseOut}>
                        <SVGIcon id="email-icon-svg" className="email-icon" markup={isEmailIconHovered ? emailIconHover : emailIconDefault}/>
                    </div>
                    <div className="resource-icon-text"><a onClick={onHelpClick} href="#">{translations[email]}</a></div>
                </div>
            </div>
            <div className="content-col-right text-center help-icon-holder">
                <div>
                    <div id="help-icon" onMouseOver={onHelpIconMouseHovered} onMouseOut={onHelpIconMouseOut}>
                        <a target="_blank" href={helpCenter}>
                            <SVGIcon id="help-icon-svg" className="help-icon" markup={isHelpIconHovered ? helpIconHover : helpIconDefault}/>
                        </a>
                    </div>
                    <div className="resource-icon-text"><a target="_blank" href={helpCenter}>{translations[help]}</a></div>
                </div>
            </div>
        </div>);
    }

    // Hide 'BacktoForm' Button in ineligibility page
    getBackFormButton() {
        const {
            ineligibilityStatusCode,
            translations
        } = this.props;

        return (ineligibilityStatusCode)
            ? null : (<div className="back-form-button">
                <SVGIcon className="back-form-icon" inline markup={ARROW_LEFT__24}/>
                <a className="back-form-text" onClick={this.props.onBackButtonClick}>{translations['ipmob.ineligible_page.content_3']}</a>
            </div>);
    }

    getIneligiblityHeadText() {
        const {translations} = this.props;
        return (((this.props.ineligibilityStatus === 'INVALID_PROPERTY_COUNT') || (this.props.ineligibilityStatus === 'INVALID_PRIVATE_OWNER')) ?
            translations[this.props.header1] :
            processTranslation(translations['ipmob.ineligible_page.heading_4'], [this.props.brandName]));
    }

    ineligibilityPage() {
        const {
            translations,
            contents,
            brandName
        } = this.props;

        const translatedContents = contents.map((content, i) => {
            return (<p key={i}>{processTranslation(translations[content], [brandName])}</p>);
        });

        return (<div className="page_content">
            {this.getBackFormButton()}
            <div className="panel-head">
                <h1 className="header"> {this.getIneligiblityHeadText()}</h1>
            </div>
            <div className="helpful-resources-wrapper">
                <div className="ineligibility-pg-desc">
                    {translatedContents}
                </div>
            </div>
            <div className="ineligibilty-pg-icon">
                {this.resources()}
            </div>
        </div>);
    }

    errorPage() {
        const {
            translations,
            header1,
            header2,
            subHeading,
            contents,
        } = this.props;

        const translatedContents = contents.map((content, i) => {
            return (<p key={i}>{translations[content]}</p>);
        });

        return (<div className="page_content">
            <div className="panel-head">
                <h1 className="head">{translations[header1]}</h1>
                <span className="sub-head">{translations[subHeading]}</span>
            </div>
            <div className="helpful-resources-wrapper">
                <div className="helpful-resources-heading">
                    {translations[header2]}
                </div>
                <div className="information-pg-desc">
                    {translatedContents}
                </div>
            </div>
            <div className="information-pg-icon">
                {this.resources()}
            </div>
        </div>);
    }

    render() {
        const {
            messageKey
        } = this.props;

        return (<div className="information-pg">
            <div className="information-pg-wrapper container">
                <img className="information-pg-bg-img" src={backgroundImage()}/>
                {
                    ((messageKey === 'ACCESS_DENIED') || (messageKey === 'ERROR'))
                        ? this.errorPage()
                        : this.ineligibilityPage()
                }
            </div>
        </div>);
    }
}
